function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (t, e) {
  "object" === (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" === (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e() : "function" === typeof define && define.amd ? define([], e) : "object" === (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["tag-textarea"] = e() : t["tag-textarea"] = e();
})("undefined" !== typeof self ? self : this, function () {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" === _typeof(t) && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        n.d(r, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = "112a");
  }({
    "008a": function a(t, e, n) {
      var r = n("f6b4");

      t.exports = function (t) {
        return Object(r(t));
      };
    },
    "064e": function e(t, _e, n) {
      var r = n("69b3"),
          o = n("db6b"),
          i = n("94b3"),
          c = Object.defineProperty;
      _e.f = n("149f") ? Object.defineProperty : function (t, e, n) {
        if (r(t), e = i(e, !0), r(n), o) try {
          return c(t, e, n);
        } catch (a) {}
        if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
        return "value" in n && (t[e] = n.value), t;
      };
    },
    "09b9": function b9(t, e, n) {
      var r = n("224c"),
          o = n("f6b4");

      t.exports = function (t) {
        return r(o(t));
      };
    },
    "0aed": function aed(t, e, n) {
      "use strict";

      n("aaba");

      var r = n("bf16"),
          o = n("86d4"),
          i = n("238a"),
          c = n("f6b4"),
          a = n("cb3d"),
          u = n("8714"),
          s = a("species"),
          f = !i(function () {
        var t = /./;
        return t.exec = function () {
          var t = [];
          return t.groups = {
            a: "7"
          }, t;
        }, "7" !== "".replace(t, "$<a>");
      }),
          l = function () {
        var t = /(?:)/,
            e = t.exec;

        t.exec = function () {
          return e.apply(this, arguments);
        };

        var n = "ab".split(t);
        return 2 === n.length && "a" === n[0] && "b" === n[1];
      }();

      t.exports = function (t, e, n) {
        var d = a(t),
            p = !i(function () {
          var e = {};
          return e[d] = function () {
            return 7;
          }, 7 != ""[t](e);
        }),
            v = p ? !i(function () {
          var e = !1,
              n = /a/;
          return n.exec = function () {
            return e = !0, null;
          }, "split" === t && (n.constructor = {}, n.constructor[s] = function () {
            return n;
          }), n[d](""), !e;
        }) : void 0;

        if (!p || !v || "replace" === t && !f || "split" === t && !l) {
          var h = /./[d],
              y = n(c, d, ""[t], function (t, e, n, r, o) {
            return e.exec === u ? p && !o ? {
              done: !0,
              value: h.call(e, n, r)
            } : {
              done: !0,
              value: t.call(n, e, r)
            } : {
              done: !1
            };
          }),
              b = y[0],
              g = y[1];
          r(String.prototype, t, b), o(RegExp.prototype, d, 2 == e ? function (t, e) {
            return g.call(t, this, e);
          } : function (t) {
            return g.call(t, this);
          });
        }
      };
    },
    "0dc8": function dc8(t, e, n) {
      var r = n("064e"),
          o = n("69b3"),
          i = n("80a9");
      t.exports = n("149f") ? Object.defineProperties : function (t, e) {
        o(t);
        var n,
            c = i(e),
            a = c.length,
            u = 0;

        while (a > u) {
          r.f(t, n = c[u++], e[n]);
        }

        return t;
      };
    },
    "0e8b": function e8b(t, e, n) {
      var r = n("cb3d")("unscopables"),
          o = Array.prototype;
      void 0 == o[r] && n("86d4")(o, r, {}), t.exports = function (t) {
        o[r][t] = !0;
      };
    },
    "112a": function a(t, e, n) {
      "use strict";

      var r;
      (n.r(e), "undefined" !== typeof window) && (n("e67d"), (r = window.document.currentScript) && (r = r.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)) && (n.p = r[1]));
      n("9dd9"), n("f548");

      function o(t) {
        return o = "function" === typeof Symbol && "symbol" === _typeof(Symbol.iterator) ? function (t) {
          return _typeof(t);
        } : function (t) {
          return t && "function" === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
        }, o(t);
      }

      n("6d57"), n("5f54");

      function i(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }

      function c(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      function a(t, e, n) {
        return e && c(t.prototype, e), n && c(t, n), t;
      }

      var u = function () {
        function t(e) {
          i(this, t), this.standards = {
            strict: "strict",
            loose: "loose",
            html5: "html5"
          }, this.selectArray = [], this.counter = 0, this.settings = {
            standard: this.standards.html5,
            extraHead: "",
            extraCss: "",
            popTitle: "",
            endCallback: null,
            ids: ""
          }, Object.assign(this.settings, e), this.init();
        }

        return a(t, [{
          key: "init",
          value: function value() {
            this.counter++, this.settings.id = "printArea_".concat(this.counter);
            var t = this.getPrintWindow();
            this.write(t.doc), this.print(t), this.settings.endCallback();
          }
        }, {
          key: "print",
          value: function value(t) {
            var e = this,
                n = t.win,
                r = function r() {
              n.focus(), n.print();

              try {
                var t = document.getElementById(e.settings.id),
                    r = e.elsdom.querySelectorAll(".canvasImg");
                console.log(e.elsdom);

                for (var o = 0; o < r.length; o++) {
                  var i = r[o].parentNode;
                  i.removeChild(r[o]);
                }

                t.parentNode.removeChild(t);
              } catch (c) {
                console.log(c);
              }
            };

            if (window.ActiveXObject) return n.onload = r(), !1;

            n.onload = function () {
              r();
            };
          }
        }, {
          key: "write",
          value: function value(t, e) {
            t.open(), t.write("".concat(this.docType(), "<html>").concat(this.getHead()).concat(this.getBody(), "</html>")), t.close();
          }
        }, {
          key: "docType",
          value: function value() {
            if (this.settings.standard === this.standards.html5) return "<!DOCTYPE html>";
            var t = this.settings.standard === this.standards.loose ? " Transitional" : "",
                e = this.settings.standard === this.standards.loose ? "loose" : "strict";
            return '<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01'.concat(t, '//EN" "http://www.w3.org/TR/html4/').concat(e, '.dtd">');
          }
        }, {
          key: "getHead",
          value: function value() {
            var t = "",
                e = "",
                n = "";
            this.settings.extraHead && this.settings.extraHead.replace(/([^,]+)/g, function (e) {
              t += e;
            }), [].forEach.call(document.querySelectorAll("link"), function (t, n) {
              t.href.indexOf(".css") >= 0 && (e += '<link type="text/css" rel="stylesheet" href="'.concat(t.href, '" >'));
            });
            var r = document.styleSheets;
            if (r && r.length > 0) for (var o = 0; o < r.length; o++) {
              try {
                if (r[o].cssRules || r[o].rules) for (var i = r[o].cssRules || r[o].rules, c = 0; c < i.length; c++) {
                  n += i[c].cssText;
                }
              } catch (a) {
                console.log(r[o].href + a);
              }
            }
            return this.settings.extraCss && this.settings.extraCss.replace(/([^,\s]+)/g, function (t) {
              e += '<link type="text/css" rel="stylesheet" href="'.concat(t, '">');
            }), "<head><title>".concat(this.settings.popTitle, "</title>").concat(t).concat(e, '<style type="text/css">').concat(n, "</style></head>");
          }
        }, {
          key: "getBody",
          value: function value() {
            var t = this.settings.ids;
            t = t.replace(new RegExp("#", "g"), ""), this.elsdom = this.beforeHanler(document.getElementById(t));
            var e = this.getFormData(this.elsdom),
                n = e.outerHTML;
            return "<body>" + n + "</body>";
          }
        }, {
          key: "beforeHanler",
          value: function value(t) {
            for (var e = t.querySelectorAll("canvas"), n = 0; n < e.length; n++) {
              if (!e[n].style.display) {
                var r = e[n].parentNode,
                    o = e[n].toDataURL("image/png"),
                    i = new Image();
                i.className = "canvasImg", i.style.display = "none", i.src = o, r.appendChild(i);
              }
            }

            return t;
          }
        }, {
          key: "getFormData",
          value: function value(t) {
            for (var e = t.cloneNode(!0), n = e.querySelectorAll("input,select,textarea"), r = e.querySelectorAll(".canvasImg,canvas"), o = -1, i = 0; i < r.length; i++) {
              var c = r[i].parentNode,
                  a = r[i];
              "canvas" === a.tagName.toLowerCase() ? c.removeChild(a) : a.style.display = "block";
            }

            for (var u = 0; u < n.length; u++) {
              var s = n[u],
                  f = s.getAttribute("type"),
                  l = n[u];
              if (f || (f = "SELECT" === s.tagName ? "select" : "TEXTAREA" === s.tagName ? "textarea" : ""), "INPUT" === s.tagName) "radio" === f || "checkbox" === f ? l.setAttribute("checked", s.checked) : (l.value = s.value, l.setAttribute("value", s.value));else if ("select" === f) {
                o++;

                for (var d = 0; d < t.querySelectorAll("select").length; d++) {
                  var p = t.querySelectorAll("select")[d];

                  if (!p.getAttribute("newbs") && p.setAttribute("newbs", d), p.getAttribute("newbs") == o) {
                    var v = t.querySelectorAll("select")[o].selectedIndex;
                    s.options[v].setAttribute("selected", !0);
                  }
                }
              } else l.innerHTML = s.value, l.setAttribute("html", s.value);
            }

            return e;
          }
        }, {
          key: "getPrintWindow",
          value: function value() {
            var t = this.Iframe();
            return {
              f: t,
              win: t.contentWindow || t,
              doc: t.doc
            };
          }
        }, {
          key: "Iframe",
          value: function value() {
            var t,
                e = this.settings.id,
                n = this;

            try {
              t = document.createElement("iframe"), document.body.appendChild(t), t.style.border = "0px", t.style.position = "absolute", t.style.width = "0px", t.style.height = "0px", t.style.right = "0px", t.style.top = "0px", t.setAttribute("id", e), t.setAttribute("src", new Date().getTime()), t.doc = null, t.doc = t.contentDocument ? t.contentDocument : t.contentWindow ? t.contentWindow.document : t.document, t.onload = function () {
                var e = t.contentWindow || t;
                n.print(e);
              };
            } catch (r) {
              throw new Error(r + ". iframes may not be supported in this browser.");
            }

            if (null == t.doc) throw new Error("Cannot find document.");
            return t;
          }
        }]), t;
      }(),
          s = {
        directiveName: "print",
        bind: function bind(t, e, n) {
          var r = n.context,
              i = !0,
              c = "";
          t.addEventListener("click", function () {
            r.$nextTick(function () {
              if ("string" === typeof e.value) c = e.value;else if ("object" === o(e.value) && e.value.id) {
                c = e.value.id;
                var t = c.replace(new RegExp("#", "g"), ""),
                    n = document.getElementById(t);
                n || (console.log("id in Error"), c = "");
              }
              c ? a() : window.print();
            });
          });

          var a = function a() {
            i && (i = !1, new u({
              ids: c,
              standard: "",
              extraHead: e.value.extraHead,
              extraCss: e.value.extraCss,
              popTitle: e.value.popTitle,
              endCallback: function endCallback() {
                i = !0;
              }
            }));
          };
        },
        install: function install(t) {
          t.directive("print", s);
        }
      },
          f = s;

      e["default"] = f;
    },
    1157: function _(t, e, n) {
      "use strict";

      var r = n("e7ad"),
          o = n("064e"),
          i = n("149f"),
          c = n("cb3d")("species");

      t.exports = function (t) {
        var e = r[t];
        i && e && !e[c] && o.f(e, c, {
          configurable: !0,
          get: function get() {
            return this;
          }
        });
      };
    },
    "149f": function f(t, e, n) {
      t.exports = !n("238a")(function () {
        return 7 != Object.defineProperty({}, "a", {
          get: function get() {
            return 7;
          }
        }).a;
      });
    },
    "1e5b": function e5b(t, e, n) {
      var r = n("fb68"),
          o = n("859b").set;

      t.exports = function (t, e, n) {
        var i,
            c = e.constructor;
        return c !== n && "function" == typeof c && (i = c.prototype) !== n.prototype && r(i) && o && o(t, i), t;
      };
    },
    "224c": function c(t, e, n) {
      var r = n("75c4");
      t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
        return "String" == r(t) ? t.split("") : Object(t);
      };
    },
    "238a": function a(t, e) {
      t.exports = function (t) {
        try {
          return !!t();
        } catch (e) {
          return !0;
        }
      };
    },
    "2ea2": function ea2(t, e, n) {
      var r = n("c2f7"),
          o = n("ceac").concat("length", "prototype");

      e.f = Object.getOwnPropertyNames || function (t) {
        return r(t, o);
      };
    },
    "2f77": function f77(t, e) {
      e.f = Object.getOwnPropertySymbols;
    },
    "2fd4": function fd4(t, e, n) {
      var r = n("fb68"),
          o = n("75c4"),
          i = n("cb3d")("match");

      t.exports = function (t) {
        var e;
        return r(t) && (void 0 !== (e = t[i]) ? !!e : "RegExp" == o(t));
      };
    },
    "32b9": function b9(t, e, n) {
      "use strict";

      var r = n("e005"),
          o = n("cc33"),
          i = n("399f"),
          c = {};
      n("86d4")(c, n("cb3d")("iterator"), function () {
        return this;
      }), t.exports = function (t, e, n) {
        t.prototype = r(c, {
          next: o(1, n)
        }), i(t, e + " Iterator");
      };
    },
    "399f": function f(t, e, n) {
      var r = n("064e").f,
          o = n("e042"),
          i = n("cb3d")("toStringTag");

      t.exports = function (t, e, n) {
        t && !o(t = n ? t : t.prototype, i) && r(t, i, {
          configurable: !0,
          value: e
        });
      };
    },
    "475d": function d(t, e) {
      t.exports = function (t, e) {
        return {
          value: e,
          done: !!t
        };
      };
    },
    "492d": function d(t, e, n) {
      "use strict";

      var r = n("550e"),
          o = n("e46b"),
          i = n("bf16"),
          c = n("86d4"),
          a = n("da6d"),
          u = n("32b9"),
          s = n("399f"),
          f = n("58cf"),
          l = n("cb3d")("iterator"),
          d = !([].keys && "next" in [].keys()),
          p = "@@iterator",
          v = "keys",
          h = "values",
          y = function y() {
        return this;
      };

      t.exports = function (t, e, n, b, g, x, m) {
        u(n, e, b);

        var w,
            S,
            O,
            E = function E(t) {
          if (!d && t in A) return A[t];

          switch (t) {
            case v:
              return function () {
                return new n(this, t);
              };

            case h:
              return function () {
                return new n(this, t);
              };
          }

          return function () {
            return new n(this, t);
          };
        },
            T = e + " Iterator",
            j = g == h,
            k = !1,
            A = t.prototype,
            _ = A[l] || A[p] || g && A[g],
            P = _ || E(g),
            L = g ? j ? E("entries") : P : void 0,
            C = "Array" == e && A.entries || _;

        if (C && (O = f(C.call(new t())), O !== Object.prototype && O.next && (s(O, T, !0), r || "function" == typeof O[l] || c(O, l, y))), j && _ && _.name !== h && (k = !0, P = function P() {
          return _.call(this);
        }), r && !m || !d && !k && A[l] || c(A, l, P), a[e] = P, a[T] = y, g) if (w = {
          values: j ? P : E(h),
          keys: x ? P : E(v),
          entries: L
        }, m) for (S in w) {
          S in A || i(A, S, w[S]);
        } else o(o.P + o.F * (d || k), e, w);
        return w;
      };
    },
    "4ce5": function ce5(t, e, n) {
      var r = n("5daa");

      t.exports = function (t, e, n) {
        if (r(t), void 0 === e) return t;

        switch (n) {
          case 1:
            return function (n) {
              return t.call(e, n);
            };

          case 2:
            return function (n, r) {
              return t.call(e, n, r);
            };

          case 3:
            return function (n, r, o) {
              return t.call(e, n, r, o);
            };
        }

        return function () {
          return t.apply(e, arguments);
        };
      };
    },
    "4f18": function f18(t, e) {
      e.f = {}.propertyIsEnumerable;
    },
    "550e": function e(t, _e2) {
      t.exports = !1;
    },
    "56f2": function f2(t, e, n) {
      var r = n("6798")("keys"),
          o = n("ec45");

      t.exports = function (t) {
        return r[t] || (r[t] = o(t));
      };
    },
    "58cf": function cf(t, e, n) {
      var r = n("e042"),
          o = n("008a"),
          i = n("56f2")("IE_PROTO"),
          c = Object.prototype;

      t.exports = Object.getPrototypeOf || function (t) {
        return t = o(t), r(t, i) ? t[i] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? c : null;
      };
    },
    "5daa": function daa(t, e) {
      t.exports = function (t) {
        if ("function" != typeof t) throw TypeError(t + " is not a function!");
        return t;
      };
    },
    "5f54": function f54(t, e, n) {
      var r = n("e46b");
      r(r.S + r.F, "Object", {
        assign: n("e118")
      });
    },
    6798: function _(t, e, n) {
      var r = n("7ddc"),
          o = n("e7ad"),
          i = "__core-js_shared__",
          c = o[i] || (o[i] = {});
      (t.exports = function (t, e) {
        return c[t] || (c[t] = void 0 !== e ? e : {});
      })("versions", []).push({
        version: r.version,
        mode: n("550e") ? "pure" : "global",
        copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
      });
    },
    "69b3": function b3(t, e, n) {
      var r = n("fb68");

      t.exports = function (t) {
        if (!r(t)) throw TypeError(t + " is not an object!");
        return t;
      };
    },
    "6d57": function d57(t, e, n) {
      for (var r = n("e44b"), o = n("80a9"), i = n("bf16"), c = n("e7ad"), a = n("86d4"), u = n("da6d"), s = n("cb3d"), f = s("iterator"), l = s("toStringTag"), d = u.Array, p = {
        CSSRuleList: !0,
        CSSStyleDeclaration: !1,
        CSSValueList: !1,
        ClientRectList: !1,
        DOMRectList: !1,
        DOMStringList: !1,
        DOMTokenList: !0,
        DataTransferItemList: !1,
        FileList: !1,
        HTMLAllCollection: !1,
        HTMLCollection: !1,
        HTMLFormElement: !1,
        HTMLSelectElement: !1,
        MediaList: !0,
        MimeTypeArray: !1,
        NamedNodeMap: !1,
        NodeList: !0,
        PaintRequestList: !1,
        Plugin: !1,
        PluginArray: !1,
        SVGLengthList: !1,
        SVGNumberList: !1,
        SVGPathSegList: !1,
        SVGPointList: !1,
        SVGStringList: !1,
        SVGTransformList: !1,
        SourceBufferList: !1,
        StyleSheetList: !0,
        TextTrackCueList: !1,
        TextTrackList: !1,
        TouchList: !1
      }, v = o(p), h = 0; h < v.length; h++) {
        var y,
            b = v[h],
            g = p[b],
            x = c[b],
            m = x && x.prototype;
        if (m && (m[f] || a(m, f, d), m[l] || a(m, l, b), u[b] = d, g)) for (y in r) {
          m[y] || i(m, y, r[y], !0);
        }
      }
    },
    7108: function _(t, e, n) {
      "use strict";

      var r = n("7e23"),
          o = RegExp.prototype.exec;

      t.exports = function (t, e) {
        var n = t.exec;

        if ("function" === typeof n) {
          var i = n.call(t, e);
          if ("object" !== _typeof(i)) throw new TypeError("RegExp exec method returned something other than an Object or null");
          return i;
        }

        if ("RegExp" !== r(t)) throw new TypeError("RegExp#exec called on incompatible receiver");
        return o.call(t, e);
      };
    },
    "75c4": function c4(t, e) {
      var n = {}.toString;

      t.exports = function (t) {
        return n.call(t).slice(8, -1);
      };
    },
    "7ddc": function ddc(t, e) {
      var n = t.exports = {
        version: "2.6.11"
      };
      "number" == typeof __e && (__e = n);
    },
    "7e23": function e23(t, e, n) {
      var r = n("75c4"),
          o = n("cb3d")("toStringTag"),
          i = "Arguments" == r(function () {
        return arguments;
      }()),
          c = function c(t, e) {
        try {
          return t[e];
        } catch (n) {}
      };

      t.exports = function (t) {
        var e, n, a;
        return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = c(e = Object(t), o)) ? n : i ? r(e) : "Object" == (a = r(e)) && "function" == typeof e.callee ? "Arguments" : a;
      };
    },
    "80a9": function a9(t, e, n) {
      var r = n("c2f7"),
          o = n("ceac");

      t.exports = Object.keys || function (t) {
        return r(t, o);
      };
    },
    "859b": function b(t, e, n) {
      var r = n("fb68"),
          o = n("69b3"),
          i = function i(t, e) {
        if (o(t), !r(e) && null !== e) throw TypeError(e + ": can't set as prototype!");
      };

      t.exports = {
        set: Object.setPrototypeOf || ("__proto__" in {} ? function (t, e, r) {
          try {
            r = n("4ce5")(Function.call, n("dcb7").f(Object.prototype, "__proto__").set, 2), r(t, []), e = !(t instanceof Array);
          } catch (o) {
            e = !0;
          }

          return function (t, n) {
            return i(t, n), e ? t.__proto__ = n : r(t, n), t;
          };
        }({}, !1) : void 0),
        check: i
      };
    },
    "86d4": function d4(t, e, n) {
      var r = n("064e"),
          o = n("cc33");
      t.exports = n("149f") ? function (t, e, n) {
        return r.f(t, e, o(1, n));
      } : function (t, e, n) {
        return t[e] = n, t;
      };
    },
    8714: function _(t, e, n) {
      "use strict";

      var r = n("f1fe"),
          o = RegExp.prototype.exec,
          i = String.prototype.replace,
          c = o,
          a = "lastIndex",
          u = function () {
        var t = /a/,
            e = /b*/g;
        return o.call(t, "a"), o.call(e, "a"), 0 !== t[a] || 0 !== e[a];
      }(),
          s = void 0 !== /()??/.exec("")[1],
          f = u || s;

      f && (c = function c(t) {
        var e,
            n,
            c,
            f,
            l = this;
        return s && (n = new RegExp("^" + l.source + "$(?!\\s)", r.call(l))), u && (e = l[a]), c = o.call(l, t), u && c && (l[a] = l.global ? c.index + c[0].length : e), s && c && c.length > 1 && i.call(c[0], n, function () {
          for (f = 1; f < arguments.length - 2; f++) {
            void 0 === arguments[f] && (c[f] = void 0);
          }
        }), c;
      }), t.exports = c;
    },
    "8df1": function df1(t, e, n) {
      var r = n("e7ad").document;
      t.exports = r && r.documentElement;
    },
    "94b3": function b3(t, e, n) {
      var r = n("fb68");

      t.exports = function (t, e) {
        if (!r(t)) return t;
        var n, o;
        if (e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o;
        if ("function" == typeof (n = t.valueOf) && !r(o = n.call(t))) return o;
        if (!e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o;
        throw TypeError("Can't convert object to primitive value");
      };
    },
    "9dd9": function dd9(t, e, n) {
      var r = n("e7ad"),
          o = n("1e5b"),
          i = n("064e").f,
          c = n("2ea2").f,
          a = n("2fd4"),
          u = n("f1fe"),
          _s = r.RegExp,
          f = _s,
          l = _s.prototype,
          d = /a/g,
          p = /a/g,
          v = new _s(d) !== d;

      if (n("149f") && (!v || n("238a")(function () {
        return p[n("cb3d")("match")] = !1, _s(d) != d || _s(p) == p || "/a/i" != _s(d, "i");
      }))) {
        _s = function s(t, e) {
          var n = this instanceof _s,
              r = a(t),
              i = void 0 === e;
          return !n && r && t.constructor === _s && i ? t : o(v ? new f(r && !i ? t.source : t, e) : f((r = t instanceof _s) ? t.source : t, r && i ? u.call(t) : e), n ? this : l, _s);
        };

        for (var h = function h(t) {
          (t in _s) || i(_s, t, {
            configurable: !0,
            get: function get() {
              return f[t];
            },
            set: function set(e) {
              f[t] = e;
            }
          });
        }, y = c(f), b = 0; y.length > b;) {
          h(y[b++]);
        }

        l.constructor = _s, _s.prototype = l, n("bf16")(r, "RegExp", _s);
      }

      n("1157")("RegExp");
    },
    aaba: function aaba(t, e, n) {
      "use strict";

      var r = n("8714");
      n("e46b")({
        target: "RegExp",
        proto: !0,
        forced: r !== /./.exec
      }, {
        exec: r
      });
    },
    b3a6: function b3a6(t, e, n) {
      var r = n("09b9"),
          o = n("eafa"),
          i = n("f58a");

      t.exports = function (t) {
        return function (e, n, c) {
          var a,
              u = r(e),
              s = o(u.length),
              f = i(c, s);

          if (t && n != n) {
            while (s > f) {
              if (a = u[f++], a != a) return !0;
            }
          } else for (; s > f; f++) {
            if ((t || f in u) && u[f] === n) return t || f || 0;
          }

          return !t && -1;
        };
      };
    },
    bf16: function bf16(t, e, n) {
      var r = n("e7ad"),
          o = n("86d4"),
          i = n("e042"),
          c = n("ec45")("src"),
          a = n("d07e"),
          u = "toString",
          s = ("" + a).split(u);
      n("7ddc").inspectSource = function (t) {
        return a.call(t);
      }, (t.exports = function (t, e, n, a) {
        var u = "function" == typeof n;
        u && (i(n, "name") || o(n, "name", e)), t[e] !== n && (u && (i(n, c) || o(n, c, t[e] ? "" + t[e] : s.join(String(e)))), t === r ? t[e] = n : a ? t[e] ? t[e] = n : o(t, e, n) : (delete t[e], o(t, e, n)));
      })(Function.prototype, u, function () {
        return "function" == typeof this && this[c] || a.call(this);
      });
    },
    bfe7: function bfe7(t, e, n) {
      var r = n("fb68"),
          o = n("e7ad").document,
          i = r(o) && r(o.createElement);

      t.exports = function (t) {
        return i ? o.createElement(t) : {};
      };
    },
    c2f7: function c2f7(t, e, n) {
      var r = n("e042"),
          o = n("09b9"),
          i = n("b3a6")(!1),
          c = n("56f2")("IE_PROTO");

      t.exports = function (t, e) {
        var n,
            a = o(t),
            u = 0,
            s = [];

        for (n in a) {
          n != c && r(a, n) && s.push(n);
        }

        while (e.length > u) {
          r(a, n = e[u++]) && (~i(s, n) || s.push(n));
        }

        return s;
      };
    },
    cb3d: function cb3d(t, e, n) {
      var r = n("6798")("wks"),
          o = n("ec45"),
          i = n("e7ad").Symbol,
          c = "function" == typeof i,
          a = t.exports = function (t) {
        return r[t] || (r[t] = c && i[t] || (c ? i : o)("Symbol." + t));
      };

      a.store = r;
    },
    cc33: function cc33(t, e) {
      t.exports = function (t, e) {
        return {
          enumerable: !(1 & t),
          configurable: !(2 & t),
          writable: !(4 & t),
          value: e
        };
      };
    },
    ceac: function ceac(t, e) {
      t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
    },
    d07e: function d07e(t, e, n) {
      t.exports = n("6798")("native-function-to-string", Function.toString);
    },
    da6d: function da6d(t, e) {
      t.exports = {};
    },
    db6b: function db6b(t, e, n) {
      t.exports = !n("149f") && !n("238a")(function () {
        return 7 != Object.defineProperty(n("bfe7")("div"), "a", {
          get: function get() {
            return 7;
          }
        }).a;
      });
    },
    dcb7: function dcb7(t, e, n) {
      var r = n("4f18"),
          o = n("cc33"),
          i = n("09b9"),
          c = n("94b3"),
          a = n("e042"),
          u = n("db6b"),
          s = Object.getOwnPropertyDescriptor;
      e.f = n("149f") ? s : function (t, e) {
        if (t = i(t), e = c(e, !0), u) try {
          return s(t, e);
        } catch (n) {}
        if (a(t, e)) return o(!r.f.call(t, e), t[e]);
      };
    },
    e005: function e005(t, e, n) {
      var r = n("69b3"),
          o = n("0dc8"),
          i = n("ceac"),
          c = n("56f2")("IE_PROTO"),
          a = function a() {},
          u = "prototype",
          _s2 = function s() {
        var t,
            e = n("bfe7")("iframe"),
            r = i.length,
            o = "<",
            c = ">";
        e.style.display = "none", n("8df1").appendChild(e), e.src = "javascript:", t = e.contentWindow.document, t.open(), t.write(o + "script" + c + "document.F=Object" + o + "/script" + c), t.close(), _s2 = t.F;

        while (r--) {
          delete _s2[u][i[r]];
        }

        return _s2();
      };

      t.exports = Object.create || function (t, e) {
        var n;
        return null !== t ? (a[u] = r(t), n = new a(), a[u] = null, n[c] = t) : n = _s2(), void 0 === e ? n : o(n, e);
      };
    },
    e042: function e042(t, e) {
      var n = {}.hasOwnProperty;

      t.exports = function (t, e) {
        return n.call(t, e);
      };
    },
    e118: function e118(t, e, n) {
      "use strict";

      var r = n("149f"),
          o = n("80a9"),
          i = n("2f77"),
          c = n("4f18"),
          a = n("008a"),
          u = n("224c"),
          s = Object.assign;
      t.exports = !s || n("238a")(function () {
        var t = {},
            e = {},
            n = Symbol(),
            r = "abcdefghijklmnopqrst";
        return t[n] = 7, r.split("").forEach(function (t) {
          e[t] = t;
        }), 7 != s({}, t)[n] || Object.keys(s({}, e)).join("") != r;
      }) ? function (t, e) {
        var n = a(t),
            s = arguments.length,
            f = 1,
            l = i.f,
            d = c.f;

        while (s > f) {
          var p,
              v = u(arguments[f++]),
              h = l ? o(v).concat(l(v)) : o(v),
              y = h.length,
              b = 0;

          while (y > b) {
            p = h[b++], r && !d.call(v, p) || (n[p] = v[p]);
          }
        }

        return n;
      } : s;
    },
    e44b: function e44b(t, e, n) {
      "use strict";

      var r = n("0e8b"),
          o = n("475d"),
          i = n("da6d"),
          c = n("09b9");
      t.exports = n("492d")(Array, "Array", function (t, e) {
        this._t = c(t), this._i = 0, this._k = e;
      }, function () {
        var t = this._t,
            e = this._k,
            n = this._i++;
        return !t || n >= t.length ? (this._t = void 0, o(1)) : o(0, "keys" == e ? n : "values" == e ? t[n] : [n, t[n]]);
      }, "values"), i.Arguments = i.Array, r("keys"), r("values"), r("entries");
    },
    e46b: function e46b(t, e, n) {
      var r = n("e7ad"),
          o = n("7ddc"),
          i = n("86d4"),
          c = n("bf16"),
          a = n("4ce5"),
          u = "prototype",
          s = function s(t, e, n) {
        var f,
            l,
            d,
            p,
            v = t & s.F,
            h = t & s.G,
            y = t & s.S,
            b = t & s.P,
            g = t & s.B,
            x = h ? r : y ? r[e] || (r[e] = {}) : (r[e] || {})[u],
            m = h ? o : o[e] || (o[e] = {}),
            w = m[u] || (m[u] = {});

        for (f in h && (n = e), n) {
          l = !v && x && void 0 !== x[f], d = (l ? x : n)[f], p = g && l ? a(d, r) : b && "function" == typeof d ? a(Function.call, d) : d, x && c(x, f, d, t & s.U), m[f] != d && i(m, f, p), b && w[f] != d && (w[f] = d);
        }
      };

      r.core = o, s.F = 1, s.G = 2, s.S = 4, s.P = 8, s.B = 16, s.W = 32, s.U = 64, s.R = 128, t.exports = s;
    },
    e67d: function e67d(t, e) {
      (function (t) {
        var e = "currentScript",
            n = t.getElementsByTagName("script");
        e in t || Object.defineProperty(t, e, {
          get: function get() {
            try {
              throw new Error();
            } catch (r) {
              var t,
                  e = (/.*at [^\(]*\((.*):.+:.+\)$/gi.exec(r.stack) || [!1])[1];

              for (t in n) {
                if (n[t].src == e || "interactive" == n[t].readyState) return n[t];
              }

              return null;
            }
          }
        });
      })(document);
    },
    e754: function e754(t, e, n) {
      "use strict";

      var r = n("fc81")(!0);

      t.exports = function (t, e, n) {
        return e + (n ? r(t, e).length : 1);
      };
    },
    e7ad: function e7ad(t, e) {
      var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
      "number" == typeof __g && (__g = n);
    },
    eafa: function eafa(t, e, n) {
      var r = n("ee21"),
          o = Math.min;

      t.exports = function (t) {
        return t > 0 ? o(r(t), 9007199254740991) : 0;
      };
    },
    ec45: function ec45(t, e) {
      var n = 0,
          r = Math.random();

      t.exports = function (t) {
        return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + r).toString(36));
      };
    },
    ee21: function ee21(t, e) {
      var n = Math.ceil,
          r = Math.floor;

      t.exports = function (t) {
        return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t);
      };
    },
    f1fe: function f1fe(t, e, n) {
      "use strict";

      var r = n("69b3");

      t.exports = function () {
        var t = r(this),
            e = "";
        return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.unicode && (e += "u"), t.sticky && (e += "y"), e;
      };
    },
    f548: function f548(t, e, n) {
      "use strict";

      var r = n("69b3"),
          o = n("008a"),
          i = n("eafa"),
          c = n("ee21"),
          a = n("e754"),
          u = n("7108"),
          s = Math.max,
          f = Math.min,
          l = Math.floor,
          d = /\$([$&`']|\d\d?|<[^>]*>)/g,
          p = /\$([$&`']|\d\d?)/g,
          v = function v(t) {
        return void 0 === t ? t : String(t);
      };

      n("0aed")("replace", 2, function (t, e, n, h) {
        return [function (r, o) {
          var i = t(this),
              c = void 0 == r ? void 0 : r[e];
          return void 0 !== c ? c.call(r, i, o) : n.call(String(i), r, o);
        }, function (t, e) {
          var o = h(n, t, this, e);
          if (o.done) return o.value;
          var l = r(t),
              d = String(this),
              p = "function" === typeof e;
          p || (e = String(e));
          var b = l.global;

          if (b) {
            var g = l.unicode;
            l.lastIndex = 0;
          }

          var x = [];

          while (1) {
            var m = u(l, d);
            if (null === m) break;
            if (x.push(m), !b) break;
            var w = String(m[0]);
            "" === w && (l.lastIndex = a(d, i(l.lastIndex), g));
          }

          for (var S = "", O = 0, E = 0; E < x.length; E++) {
            m = x[E];

            for (var T = String(m[0]), j = s(f(c(m.index), d.length), 0), k = [], A = 1; A < m.length; A++) {
              k.push(v(m[A]));
            }

            var _ = m.groups;

            if (p) {
              var P = [T].concat(k, j, d);
              void 0 !== _ && P.push(_);
              var L = String(e.apply(void 0, P));
            } else L = y(T, d, j, k, _, e);

            j >= O && (S += d.slice(O, j) + L, O = j + T.length);
          }

          return S + d.slice(O);
        }];

        function y(t, e, r, i, c, a) {
          var u = r + t.length,
              s = i.length,
              f = p;
          return void 0 !== c && (c = o(c), f = d), n.call(a, f, function (n, o) {
            var a;

            switch (o.charAt(0)) {
              case "$":
                return "$";

              case "&":
                return t;

              case "`":
                return e.slice(0, r);

              case "'":
                return e.slice(u);

              case "<":
                a = c[o.slice(1, -1)];
                break;

              default:
                var f = +o;
                if (0 === f) return n;

                if (f > s) {
                  var d = l(f / 10);
                  return 0 === d ? n : d <= s ? void 0 === i[d - 1] ? o.charAt(1) : i[d - 1] + o.charAt(1) : n;
                }

                a = i[f - 1];
            }

            return void 0 === a ? "" : a;
          });
        }
      });
    },
    f58a: function f58a(t, e, n) {
      var r = n("ee21"),
          o = Math.max,
          i = Math.min;

      t.exports = function (t, e) {
        return t = r(t), t < 0 ? o(t + e, 0) : i(t, e);
      };
    },
    f6b4: function f6b4(t, e) {
      t.exports = function (t) {
        if (void 0 == t) throw TypeError("Can't call method on  " + t);
        return t;
      };
    },
    fb68: function fb68(t, e) {
      t.exports = function (t) {
        return "object" === _typeof(t) ? null !== t : "function" === typeof t;
      };
    },
    fc81: function fc81(t, e, n) {
      var r = n("ee21"),
          o = n("f6b4");

      t.exports = function (t) {
        return function (e, n) {
          var i,
              c,
              a = String(o(e)),
              u = r(n),
              s = a.length;
          return u < 0 || u >= s ? t ? "" : void 0 : (i = a.charCodeAt(u), i < 55296 || i > 56319 || u + 1 === s || (c = a.charCodeAt(u + 1)) < 56320 || c > 57343 ? t ? a.charAt(u) : i : t ? a.slice(u, u + 2) : c - 56320 + (i - 55296 << 10) + 65536);
        };
      };
    }
  });
});